/**
 * Nox: Auf- und Zuklappen des Inline-Suchpanels in der Kopfzeile.
 *
 * `PredictiveSearchComponent` kennt kein Auf- und Zuklappen — im Original
 * uebernimmt das der Dialog, der sie umschliesst. Inline im Header brauchen wir
 * die Steuerung selbst. Sie ist absichtlich klein: eine Klasse am Wrapper, das
 * Sichtbare macht assets/nox-css.css.
 *
 * Zu beachten: die Komponente laedt beim Verbinden von sich aus die zuletzt
 * angesehenen Produkte ins Panel (predictive-search.js, connectedCallback).
 * Ohne diese Steuerung stuende das Panel deshalb schon beim Seitenaufruf offen.
 */

const OFFEN = 'nox-search--offen';

class NoxSearchInline extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.nox-search__input');
    this.panel = this.querySelector('.nox-search__panel');
    if (!this.input || !this.panel) return;

    this.input.addEventListener('focus', this.oeffnen);
    this.input.addEventListener('input', this.oeffnen);
    this.addEventListener('keydown', this.beiTaste);

    // Klick ausserhalb schliesst. `pointerdown` statt `click`, damit ein Klick
    // auf ein Ergebnis noch durchgeht, bevor das Panel verschwindet.
    document.addEventListener('pointerdown', this.beiKlickAussen);
  }

  disconnectedCallback() {
    document.removeEventListener('pointerdown', this.beiKlickAussen);
  }

  oeffnen = () => {
    this.classList.add(OFFEN);
  };

  schliessen = () => {
    this.classList.remove(OFFEN);
  };

  beiTaste = (event) => {
    if (event.key !== 'Escape') return;

    // Erst der Inhalt, dann das Panel: bei gefuelltem Feld leert Escape nur die
    // Eingabe, sonst klappt es zu. So verhaelt es sich wie ein Suchfeld, nicht
    // wie ein Dialog.
    if (this.input.value !== '') {
      this.querySelector('.nox-search__reset')?.click();
      return;
    }

    this.schliessen();
    this.input.blur();
  };

  beiKlickAussen = (event) => {
    if (!this.contains(event.target)) this.schliessen();
  };
}

if (!customElements.get('nox-search-inline')) {
  customElements.define('nox-search-inline', NoxSearchInline);
}
